import { MarketingLayout } from "@/components/marketing/marketing-layout";
import { LegalPageView } from "@/components/legal/legal-page";
import { LEGAL_PAGES } from "@/lib/legal";
import { useDocumentHead } from "@/lib/document-head";

export function PrivacyPage() {
  useDocumentHead({
    title: "Privacy Policy | Swift MVP",
    description:
      "How Swift MVP collects, uses, and protects personal information from clients and visitors.",
    canonical: "/privacy",
  });
  return (
    <MarketingLayout>
      <div className="mx-auto max-w-3xl px-6 py-12">
        <LegalPageView page={LEGAL_PAGES.privacy} />
      </div>
    </MarketingLayout>
  );
}
